// Teks isian yang memuat kata "tahun" mengikuti tahun e-Monev yang dipilih
// (mis. "Laporan Tahunan Tahun 2025" tampil sesuai tahun terpilih).
export function withYear(text, year) {
  if (!text || typeof text !== "string") return text;
  if (!/\btahun\b/i.test(text)) return text;
  return text.replace(/\b20\d{2}\b/g, String(year));
}